/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Pair } from './pair';

/**
 * Zero hash clob external trade dto
 */
export interface ZeroHashClobExternalTradeDto {
  side: ZeroHashClobExternalTradeDto.SideEnum;
  pair: Pair;
  qty: number;
  price: number;
  volume: number;
  timestamp: string;
}
export namespace ZeroHashClobExternalTradeDto {
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
}
